import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import useAuth from './UseAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Special handling for reset-password route
  if (location.pathname === '/auth/reset-password') {
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    
    // Allow access if token and email are present
    if (token && email) {
      return children;
    }
  }
  if (location.pathname === '/auth/forgot-password') {
    return children;
  }
  // For all other auth routes
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default GuestGuard;